import { lazy } from 'react'

export const AuthValidateEmail = lazy(
  () => import('features/Auth/components/AuthValidateEmail/AuthValidateEmail'),
)
